module.exports = __webpack_public_path__ + "img/seo-result2.480216c0.png";